import React from 'react';
import queryString from 'query-string';
import { useLocation, useParams } from 'react-router';
import useGetRequest from '../../../hooks/useGetRequest';


const Integrations = () => {
  const location = useLocation();
  const { code, state } = queryString.parse(location.search);
  const { integration } = useParams();

  useGetRequest({
    url: `/automatic/integrations/${integration}/`,
    payload: { code },
    methodOverride: 'post',
    onSuccess: (res: any) => {
      // @ts-ignore
      window.location = state;
    }
  });

  // todo, connecting... -> redirect if success, failure page otherwise
  return <div />;
};

export default Integrations;
